var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoInvestors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_64755)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_31_64755)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.0499,
    cy: 41.5158,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.976,
    cy: 59.1769,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.456,
    cy: 68.2462,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.069,
    cy: 98.318,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.307,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.565 100.347C167.565 137.155 137.461 167.008 100.307 167.008C63.1531 167.008 33.0488 137.155 33.0488 100.347C33.0488 63.5387 63.1531 33.6851 100.307 33.6851C137.461 33.6851 167.565 63.5387 167.565 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.6144,
    cy: 69.6784,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.1671,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.671,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.95,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.697,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 128.471,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.853,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 174.293,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.568,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 180.26,
    cy: 123.617,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.08,
    cy: 93.5449,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.955,
    cy: 77.3154,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 186.467,
    cy: 40.7998,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.8164,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.6855,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.459,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 13.4336,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.3554,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.69333,
    cy: 94.4995,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.5488,
    cy: 64.6665,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.3672,
    cy: 22.4228,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.8828,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 108.422,
    cy: 24.8095,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.437,
    cy: 18.8427,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.476 150.347C169.421 150.347 168.566 149.493 168.566 148.438C168.566 147.384 169.421 146.529 170.476 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51172 117.65C7.56621 117.65 8.42104 116.795 8.42104 115.741C8.42104 114.686 7.56621 113.832 6.51172 113.832",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 22.4226C75.5857 22.4226 76.4406 21.5678 76.4406 20.5133C76.4406 19.4588 75.5857 18.604 74.5312 18.604",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.832 15.7399C119.778 15.7399 118.923 16.5948 118.923 17.6493C118.923 18.7038 119.778 19.5586 120.832 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3301 166.934H16.2967M26.3207 155.836V157.388M38.0153 166.934H39.5666M26.3207 176.481V178.271M26.3207 180.658V186.982M21.9053 166.934C24.8887 166.934 26.44 162.638 26.44 162.638C26.44 162.638 26.9173 166.934 30.736 166.934C29.0176 166.934 26.5593 168.486 26.3207 171.588C26.3207 171.588 26.0428 169.048 25.1273 168.128C24.363 167.359 21.9053 166.934 21.9053 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.709 30.0596L172.742 30.0596M162.599 45.8115L162.718 39.6062M151.024 30.0596L149.472 30.0596M162.599 20.7516L162.599 8.57973M167.134 30.0596C164.15 30.0596 162.599 34.3556 162.599 34.3556C162.599 34.3556 162.122 30.0596 158.303 30.0596C160.021 30.0596 162.48 28.5083 162.718 25.4056C162.718 25.4056 162.996 27.9458 163.912 28.8663C164.676 29.6348 167.134 30.0596 167.134 30.0596Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5 120H68.5C75.1274 120 80.5 125.373 80.5 132V157H39.5V132C39.5 125.373 44.8726 120 51.5 120Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5 120H147.5C154.127 120 159.5 125.373 159.5 132V157H118.5V132C118.5 125.373 123.873 120 130.5 120Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 53H110.5C117.127 53 122.5 58.3726 122.5 65V95H76.5V65C76.5 58.3726 81.8726 53 88.5 53Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 108C74.5 116.314 67.9784 123 60 123C52.0216 123 45.5 116.314 45.5 108C45.5 99.6856 52.0216 93 60 93C67.9784 93 74.5 99.6856 74.5 108Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5 108C153.5 116.314 146.978 123 139 123C131.022 123 124.5 116.314 124.5 108C124.5 99.6856 131.022 93 139 93C146.978 93 153.5 99.6856 153.5 108Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 39,
    r: 17,
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9516 140.72C64.5883 140.067 64.0421 139.5 63.3273 139.034C62.6561 138.595 61.6417 138.16 60.2256 137.701C58.7256 137.216 58.0331 136.782 57.7179 136.504C57.3469 136.177 57.1669 135.711 57.1669 135.079C57.1669 134.417 57.3726 133.912 57.796 133.533C58.2344 133.141 58.862 132.95 59.715 132.95C60.5284 132.95 61.1414 133.186 61.5893 133.67C62.0659 134.186 62.2976 134.889 62.2976 135.82C62.2976 136.275 62.6843 136.644 63.162 136.644H64.511C64.9886 136.644 65.3754 136.275 65.3754 135.82C65.3754 134.196 64.9395 132.876 64.0802 131.896C63.4827 131.214 62.718 130.729 61.7975 130.447C61.4387 130.337 61.192 130.024 61.192 129.664V128.823C61.192 128.369 60.8048 128 60.3276 128H59.171C58.6937 128 58.307 128.369 58.307 128.823V129.642C58.307 130.006 58.0533 130.325 57.6867 130.429C56.8135 130.677 56.0719 131.094 55.4715 131.674C54.5543 132.56 54.0891 133.716 54.0891 135.108C54.0891 136.434 54.5143 137.54 55.3534 138.396C56.1529 139.211 57.4503 139.88 59.2964 140.431C60.8507 140.944 61.545 141.395 61.8544 141.683C62.2286 142.032 62.4108 142.481 62.4108 143.055C62.4108 143.693 62.1854 144.174 61.7008 144.565C61.1813 144.986 60.5057 145.19 59.6358 145.19C58.6285 145.19 57.8836 144.954 57.359 144.468C56.8406 143.988 56.5888 143.317 56.5888 142.418C56.5888 141.963 56.2017 141.594 55.7244 141.594H54.3644C53.8867 141.594 53.5 141.963 53.5 142.418C53.5 144.05 54.0011 145.371 54.9909 146.344C55.6779 147.018 56.558 147.487 57.6185 147.744C58.002 147.837 58.2725 148.163 58.2725 148.54V149.177C58.2725 149.631 58.6596 150 59.1369 150H60.2825C60.7598 150 61.1469 149.631 61.1469 149.177V148.501C61.1469 148.13 61.4108 147.81 61.7865 147.709C62.6942 147.465 63.4618 147.053 64.0788 146.477C65.0216 145.596 65.5 144.437 65.5 143.033C65.5 142.152 65.3156 141.374 64.9516 140.72Z",
    fill: "#787E8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.952 140.72C144.588 140.067 144.042 139.5 143.327 139.034C142.656 138.595 141.642 138.16 140.226 137.701C138.726 137.216 138.033 136.782 137.718 136.504C137.347 136.177 137.167 135.711 137.167 135.079C137.167 134.417 137.373 133.912 137.796 133.533C138.234 133.141 138.862 132.95 139.715 132.95C140.528 132.95 141.141 133.186 141.589 133.67C142.066 134.186 142.298 134.889 142.298 135.82C142.298 136.275 142.684 136.644 143.162 136.644H144.511C144.989 136.644 145.375 136.275 145.375 135.82C145.375 134.196 144.939 132.876 144.08 131.896C143.483 131.214 142.718 130.729 141.798 130.447C141.439 130.337 141.192 130.024 141.192 129.664V128.823C141.192 128.369 140.805 128 140.328 128H139.171C138.694 128 138.307 128.369 138.307 128.823V129.642C138.307 130.006 138.053 130.325 137.687 130.429C136.814 130.677 136.072 131.094 135.471 131.674C134.554 132.56 134.089 133.716 134.089 135.108C134.089 136.434 134.514 137.54 135.353 138.396C136.153 139.211 137.45 139.88 139.296 140.431C140.851 140.944 141.545 141.395 141.854 141.683C142.229 142.032 142.411 142.481 142.411 143.055C142.411 143.693 142.185 144.174 141.701 144.565C141.181 144.986 140.506 145.19 139.636 145.19C138.628 145.19 137.884 144.954 137.359 144.468C136.841 143.988 136.589 143.317 136.589 142.418C136.589 141.963 136.202 141.594 135.724 141.594H134.364C133.887 141.594 133.5 141.963 133.5 142.418C133.5 144.05 134.001 145.371 134.991 146.344C135.678 147.018 136.558 147.487 137.619 147.744C138.002 147.837 138.273 148.163 138.273 148.54V149.177C138.273 149.631 138.66 150 139.137 150H140.282C140.76 150 141.147 149.631 141.147 149.177V148.501C141.147 148.13 141.411 147.81 141.787 147.709C142.694 147.465 143.462 147.053 144.079 146.477C145.022 145.596 145.5 144.437 145.5 143.033C145.5 142.152 145.316 141.374 144.952 140.72Z",
    fill: "#787E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7074 86.4148C95.4458 86.4148 92.3808 85.1439 90.0741 82.8407C87.7674 80.5375 86.5 77.469 86.5 74.2074C86.5 70.9458 87.7709 67.8808 90.0741 65.5741C92.3772 63.2674 95.4458 62 98.7074 62C101.969 62 105.034 63.2709 107.341 65.5741C109.647 67.8772 110.915 70.9458 110.915 74.2074C110.915 77.469 109.644 80.534 107.341 82.8407C105.038 85.1474 101.969 86.4148 98.7074 86.4148ZM98.7074 62.1404C95.4844 62.1404 92.4545 63.3973 90.1759 65.6759C87.8973 67.9545 86.6404 70.9844 86.6404 74.2074C86.6404 77.4304 87.8973 80.4603 90.1759 82.7389C92.4545 85.0175 95.4844 86.2744 98.7074 86.2744C101.93 86.2744 104.96 85.0175 107.239 82.7389C109.517 80.4603 110.774 77.4304 110.774 74.2074C110.774 70.9844 109.517 67.9545 107.239 65.6759C104.96 63.3973 101.93 62.1404 98.7074 62.1404Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7082 83.2026C96.3068 83.2026 94.0492 82.2687 92.35 80.5694C90.6507 78.8701 89.7168 76.6126 89.7168 74.2111C89.7168 71.8097 90.6507 69.5522 92.35 67.8529C94.0492 66.1536 96.3068 65.2197 98.7082 65.2197C101.11 65.2197 103.367 66.1536 105.066 67.8529C106.766 69.5522 107.7 71.8097 107.7 74.2111C107.7 76.6126 106.766 78.8701 105.066 80.5694C103.367 82.2687 101.11 83.2026 98.7082 83.2026ZM98.7082 65.3531C96.3419 65.3531 94.1195 66.273 92.4483 67.9477C90.7771 69.6189 89.8537 71.8413 89.8537 74.2076C89.8537 76.574 90.7736 78.7964 92.4483 80.4676C94.1195 82.1387 96.3419 83.0621 98.7082 83.0621C101.075 83.0621 103.297 82.1423 104.968 80.4676C106.639 78.7964 107.563 76.574 107.563 74.2076C107.563 71.8413 106.643 69.6189 104.968 67.9477C103.297 66.2765 101.075 65.3531 98.7082 65.3531Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.707 77.6938C96.7831 77.6938 95.2207 76.1315 95.2207 74.2075C95.2207 72.2835 96.7831 70.7212 98.707 70.7212C100.631 70.7212 102.193 72.2835 102.193 74.2075C102.193 76.1315 100.631 77.6938 98.707 77.6938ZM98.707 70.8616C96.8638 70.8616 95.3611 72.3643 95.3611 74.2075C95.3611 76.0507 96.8638 77.5534 98.707 77.5534C100.55 77.5534 102.053 76.0507 102.053 74.2075C102.053 72.3643 100.55 70.8616 98.707 70.8616Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M104.101 76.395C107.238 76.395 109.781 73.8517 109.781 70.7143C109.781 67.577 107.238 65.0337 104.101 65.0337C100.963 65.0337 98.4199 67.577 98.4199 70.7143C98.4199 73.8517 100.963 76.395 104.101 76.395Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7074 86.4148C95.4458 86.4148 92.3808 85.1439 90.0741 82.8407C87.7674 80.5375 86.5 77.469 86.5 74.2074C86.5 70.9458 87.7709 67.8808 90.0741 65.5741C92.3772 63.2674 95.4458 62 98.7074 62C101.969 62 105.034 63.2709 107.341 65.5741C109.647 67.8772 110.915 70.9458 110.915 74.2074C110.915 77.469 109.644 80.534 107.341 82.8407C105.038 85.1474 101.969 86.4148 98.7074 86.4148ZM98.7074 62.1404C95.4844 62.1404 92.4545 63.3973 90.1759 65.6759C87.8973 67.9545 86.6404 70.9844 86.6404 74.2074C86.6404 77.4304 87.8973 80.4603 90.1759 82.7389C92.4545 85.0175 95.4844 86.2744 98.7074 86.2744C101.93 86.2744 104.96 85.0175 107.239 82.7389C109.517 80.4603 110.774 77.4304 110.774 74.2074C110.774 70.9844 109.517 67.9545 107.239 65.6759C104.96 63.3973 101.93 62.1404 98.7074 62.1404Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M88.7233 74.917C87.9931 74.917 87.2874 75.0153 86.6133 75.1979C86.6695 75.8755 86.7783 76.5355 86.9398 77.178C87.5015 77.0025 88.1019 76.9077 88.7233 76.9077C92.0306 76.9077 94.7129 79.59 94.7129 82.8973C94.7129 83.8101 94.5093 84.6773 94.1406 85.4532C94.7551 85.7025 95.3976 85.9061 96.0576 86.0536C96.4754 85.0846 96.7071 84.0208 96.7071 82.9008C96.7036 78.4911 93.1295 74.917 88.7233 74.917Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.601 65.9463C106.755 65.037 105.776 64.2576 104.687 63.6432C105.354 64.3243 105.769 65.2547 105.769 66.2834C105.769 68.3654 104.083 70.0506 102.001 70.0506C99.9195 70.0506 98.2342 68.3654 98.2342 66.2834C98.2342 64.2085 99.9089 62.5267 101.98 62.5162C100.941 62.2248 99.8422 62.0703 98.7117 62.0703C98.5713 62.0703 98.4309 62.0738 98.2904 62.0773C97.1283 63.106 96.3945 64.6087 96.3945 66.2834C96.3945 69.3835 98.9048 71.8938 102.005 71.8938C105.105 71.8938 107.615 69.3835 107.615 66.2834C107.612 66.171 107.605 66.0587 107.601 65.9463Z",
    fill: "#194590"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_64755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_31_64755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInvestors);
export default __webpack_public_path__ + "static/media/no-investors.dd61eef5a398f1ac1eba2197ff17f26d.svg";
export { ForwardRef as ReactComponent };